import { render } from "./RecipeLike.vue?vue&type=template&id=24cbea45"
import script from "./RecipeLike.vue?vue&type=script&lang=js"
export * from "./RecipeLike.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__